var React = require('react');

function Bs (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"fillOpacity":".7","d":"M-12 0h640v480H-12z"}))),React.createElement("g",{"fillRule":"evenodd","clipPath":"url(#a)","transform":"translate(12)","key":1},[React.createElement("path",{"fill":"#fff","d":"M968.5 480h-979V1.8h979z","key":0}),React.createElement("path",{"fill":"#ffe900","d":"M968.5 344.5h-979V143.3h979z","key":1}),React.createElement("path",{"fill":"#08ced6","d":"M968.5 480h-979V320.6h979zm0-318.7h-979V2h979z","key":2}),React.createElement("path",{"d":"M-11 0c2.3 0 391.8 236.8 391.8 236.8L-12 479.2-10.9 0z","key":3})])]);
}

Bs.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Bs;

Bs.default = Bs;
